import React from 'react';
import { motion } from 'framer-motion';
const bonos = [{
  num: '01',
  name: 'Kit de Rescate CV en 30 Minutos',
  desc: 'Corregís los errores más graves hoy',
  val: '$8.000'
}, {
  num: '02',
  name: '100 Frases Poderosas',
  desc: 'Mejorás el CV sin inventar experiencia',
  val: '$10.000'
}, {
  num: '03',
  name: 'Checklist Maestra',
  desc: 'Revisás todo antes de apretar enviar',
  val: '$9.000'
}, {
  num: '04',
  name: '120 Títulos Profesionales',
  desc: 'El título que te hace entender en segundos',
  val: '$8.000'
}, {
  num: '05',
  name: '40 Logros Listos para Adaptar',
  desc: 'Funciones que se convierten en impacto',
  val: '$9.000'
}, {
  num: '06',
  name: 'Plan de 14 Días',
  desc: 'Sistema diario para conseguir más entrevistas',
  val: '$9.000'
}];
export function Bonuses() {
  return <section className="py-20 px-4 mt-[-80px] mb-[-80px]" data-id="element-11">
      <div className="max-w-5xl mx-auto" data-id="element-12">
        <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-2" data-id="element-13">
          🎁 LOS 6 BONOS — SIEMPRE INCLUIDOS
        </h3>

        <div className="bg-[#0a1628] rounded-2xl border border-[#d4a843]/30 overflow-hidden shadow-[0_0_30px_rgba(212,168,67,0.1)] mb-8" data-id="element-14">
          <div className="overflow-x-auto hide-scrollbar" data-id="element-15">
            <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-16">
              <thead data-id="element-17">
                <tr className="bg-[#d4a843]/10 border-b border-[#d4a843]/20" data-id="element-18">
                  <th className="py-4 px-6 text-[#d4a843] font-semibold w-16" data-id="element-19">
                    #
                  </th>
                  <th className="py-4 px-6 text-[#d4a843] font-semibold" data-id="element-20">
                    Bono
                  </th>
                  <th className="py-4 px-6 text-[#d4a843] font-semibold text-right w-32" data-id="element-21">
                    Valor
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-22">
                {bonos.map((bono, i) => <motion.tr initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: i * 0.05
              }} key={i} className="border-b border-slate-800/50 hover:bg-[#112240]/50 transition-colors" data-id="element-23">
                    <td className="py-5 px-6 font-mono text-slate-500 font-bold" data-id="element-24">
                      {bono.num}
                    </td>
                    <td className="py-5 px-6" data-id="element-25">
                      <p className="font-bold text-white mb-1" data-id="element-26">{bono.name}</p>
                      <p className="text-sm text-slate-400" data-id="element-27">— {bono.desc}</p>
                    </td>
                    <td className="py-5 px-6 text-right" data-id="element-28">
                      <span className="line-through text-slate-500 text-sm block mb-1" data-id="element-29">
                        {bono.val}
                      </span>
                      <span className="font-bold text-green-400 bg-green-400/10 px-2 py-1 rounded text-sm" data-id="element-30">
                        GRATIS
                      </span>
                    </td>
                  </motion.tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <div className="text-center bg-gradient-to-r from-[#112240] via-[#1a2b4c] to-[#112240] py-6 rounded-xl border border-[#d4a843]/20" data-id="element-31">
          <p className="text-xl md:text-2xl font-bold text-white" data-id="element-32">
            Valor total bonos:{' '}
            <span className="line-through text-slate-400 ml-2" data-id="element-33">$53.000</span>
            <span className="text-[#d4a843] ml-3" data-id="element-34">
              → GRATIS con tu MegaPack
            </span>
          </p>
        </div>
      </div>
    </section>;
}